import { Instance, types } from "mobx-state-tree";

export const UploadImageStateModel = types
  .model({
    imageForUpload: types.optional(types.frozen(), null),
    shouldDeleteCurrentImage: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    upload(value: any) {
      self.imageForUpload = value;
      self.shouldDeleteCurrentImage = false;
    },
    removeImage() {
      if (self.imageForUpload) self.imageForUpload = null;
      else self.shouldDeleteCurrentImage = true;
    },
    undoRemoveImage() {
      self.shouldDeleteCurrentImage = false;
    },
    shouldUpdateImage() {
      if (!!self.imageForUpload || self.shouldDeleteCurrentImage) return true;
      return false;
    },
  }));

export type ImageUploadState = Instance<typeof UploadImageStateModel>;
